import {AtomProp, useIsAtomFocused} from "../../model/editor";

export const FocusContainer = ({
  atom,
  children,
}: AtomProp & {
  children: ({isFocused}: {isFocused: boolean}) => JSX.Element;
}) => children({isFocused: useIsAtomFocused(atom)});
